import React from "react";
import * as firebase from "firebase";
import { PopupModal } from "components/Modal";
import "./onboardingPopup.scss";

import { useLocalStorage } from "hooks/useLocalStorage";
import { useAuth } from "hooks/useAuth";

function OnboardingPopup() {
  const auth = useAuth();
  const usernameRef = React.useRef();
  const [showProfileModal, setShowProfileModal] = React.useState(false);
  const [hasOnboarded, setHasOnboarded] = useLocalStorage(
    "hasOnboarded",
    false
  );
  React.useEffect(() => {
    // XXX: Give it a second as the user might already have set up their username
    //      but the app is still loading the profile from the backend
    const timer = setTimeout(() => {
      setShowProfileModal(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);
  if (auth.user && !hasOnboarded) {
    return (
      <PopupModal
        isOpen={true}
        title="Welcome to SolveFaction!"
        body="Test"
        primaryActionText="Let's go!"
        onPrimaryAction={() => setHasOnboarded(true)}
      >
        <OnboardText />
      </PopupModal>
    );
  }
  if (auth.user && !(auth.profile || {}).username) {
    return (
      <PopupModal
        isOpen={showProfileModal}
        title="Welcome to SolveFaction!"
        body="Test"
        primaryActionText="Let's go!"
        onPrimaryAction={() => {
          if (usernameRef.current && usernameRef.current.value) {
          }
          const data = {
            username: usernameRef.current.value,
            userId: auth.user.uid
          };
          if (auth.profile && auth.profile.id) {
            firebase
              .firestore()
              .collection("users")
              .doc(auth.profile.id)
              .set(data, { merge: true });
          } else {
            firebase.firestore().collection("users").add(data);
          }
        }}
      >
        <p>You may now select your username.</p>
        <p>
          <input
            type="text"
            ref={usernameRef}
            placeholder="username"
            onKeyDown={e => {
              // XXX: Allow any char for now in case people want to add emojis and stuff
              // if (!/[a-zA-Z0-9_-]/.test(e.key)) {
              //   return e.preventDefault();
              // }
            }}
          />
        </p>

        <p>
          Usernames are public and displayed in the{" "}
          <a href="https://solvefaction.com/leaderboard" target="_blank">
            🏆 Leaderboard
          </a>
          .
        </p>
      </PopupModal>
    );
  }

  return null;

  function OnboardText() {
    return (
      <>
        <p>
          Before we start, take a moment to{" "}
          <b>add SolveFaction to your home screen</b> (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://photos.google.com/share/AF1QipNnGA7InwlIh5CiZ6MZU6VxZHnlmw1_e5ozGAh73-RD95Fc0pTop1o24EPCVjhgtw/photo/AF1QipMLfxdusA4OkWfZXtrJMj9NaIbC0-UWkyBLg_k?key=SEktc1dFdnhoN1VnSF9PUl9iRndmVzRhX2RfZlVn"
          >
            Android
          </a>
          ,{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.youtube.com/watch?v=I4e1aoi0P-o"
          >
            iOS
          </a>
          ) — it feels better ✨.
        </p>
        <p>
          Then, <b>3 important things</b>. As early SF members, let's make sure
          we:
          <br />
        </p>
        <p>
          – Use the 👍/ 👎 and “Report a problem” buttons. It feeds back into
          content quality 🙌
        </p>
        <p>
          – Ask questions and share insights on the forum. Help and get helped
          🙏
        </p>
        <p>
          – Take the rating (score) with a grain of salt. It’s not fully
          calibrated. But the data won’t be lost. After calibration, we will
          retroactively apply your answers and calculate the actual rating for
          you 🏆
        </p>
      </>
    );
  }
}

export { OnboardingPopup };
